import { GroupItem, ReportIcon } from '@halo/ui-chat-react';
import { useTranslation } from 'react-i18next';

export interface ReportCardProps {
  handleReport: () => void;
}

const ReportCard = ({ handleReport }: ReportCardProps) => {
  const { t } = useTranslation();
  return (
    <GroupItem
      icon={<ReportIcon />}
      title={t('chatSettings.reportCard')}
      onClick={handleReport}
    />
  );
};

const MemoizedReportCard = memo(ReportCard);
export { MemoizedReportCard as ReportCard };
